<template>
    <div class="main">
        <v-form
          ref="form"
        >

           <v-text-field
                dense
                :value="announcement"
                label="Announcement"
                class="inputWidth mt-1 "
                readonly
            ></v-text-field>

             <v-text-field
                dense
                v-model="title"
                label="Update Title"
                class="inputWidth mt-1 "
                clearable
                :rules="valueRequiredRule"
                validate-on-blur
            ></v-text-field>

             <v-checkbox
            v-model="useTemplate"
            label="Use Template"
            class="mt-1 "
            @change="onUseTemplateChange"
            ></v-checkbox>

             <free-message-editor
                label="Update Body"
                v-model="body"
                :minHeight="250"
                :height="250"
                :rules="valueRequiredRule"
            ></free-message-editor>

            <permission-input label="Permission" :items="permissionList" v-model="selectedPermission" class="mt-3 "></permission-input>


            <v-checkbox
                v-model="addTimeStamp"
                label="Add Time Stamp"
                class="mt-1 "
            ></v-checkbox>

             <v-select
                dense
                v-model="timezoneSname"
                :items="commTimezoneList"
                item-text="timezone"
                item-value="timezoneSname"
                label="Default Timezone"
                class="inputWidth mt-1 ">
            </v-select>

            <v-btn
                small
                color="primary"
                class="mr-4"
                @click="validate"
                width=70
            >
             Save
          </v-btn>

          <v-btn
                small
                color="primary"
                class="mr-4"
                @click="cancel"
                width=70
            >
             Cancel
          </v-btn>
        
        </v-form>
    </div>
</template>
<script>
import FreeMessageEditor from "@/components/Communication/FreeMessageEditor";
import PermissionInput from "@/components/Communication/PermissionInput";

const DEFAULT_TIMEZONE_US_EST = 'EST';

export default {
    name:"CommunicationUpdate",
    components:{
     "permission-input":PermissionInput,
     "free-message-editor":FreeMessageEditor
    },
    data(){
        return{
            valueRequiredRule:[
              v => !!v || 'Required.',
            ],
            commId:null,
            commTitle:null,
            title:"",
            useTemplate:false,
            body:null,
            selectedPermission:[],
            addTimeStamp:false,
            timezoneSname:null,
            complete:false,
            permissionList:[],
            permissionType:"update",
            updateBodyTemplate:null,
            templateTypeId:null,
            orgTemplateTypeId:null
        }
    },
    computed:{
        announcement(){
            if(this.commId && this.commTitle){
                return this.commId + " - " + this.commTitle;
            }else{
                return "";
            }
        },
        fields(){
            return this.$store.getters.getCommuicationFields;
        },
        commTimezoneList(){
            return (this.fields && this.fields.commTimezoneList) ? this.fields.commTimezoneList:[];
        },
        commUpdateTemplateList(){
            return (this.fields && this.fields.commUpdateTemplateList) ? this.fields.commUpdateTemplateList:[];
        }
    },
    mounted(){
        this.$refs.form.reset();
        this.timezoneSname = DEFAULT_TIMEZONE_US_EST;
        //CA-6181 set add time stamp to true by default
        this.addTimeStamp = true;
        this.$vuetify.goTo(0);
        this.$store.dispatch("fetchCommunicationField");
        this.complete = false;
        //load original communication
        if(this.$route.params && this.$route.params.communicationId){
            this.loadCommunication(this.$route.params.communicationId);
        }

         //load communication update
        if(this.$route.params && this.$route.params.updateId){
            this.loadCommunicationUpdate(this.$route.params.updateId);
        }
    },
    methods:{
          validate(){
            const valid = this.$refs.form.validate();
             console.log(valid);
            if(!valid) {
                return;
            }
            const confirmObject = {};
            confirmObject.showDlg = true;
            confirmObject.buttons={
                OKButton:{
                    Caption:"OK"
                },
                CancelButton:{
                    Caption:"Cancel"
                }
            };
            confirmObject.title="Warning Message";
            confirmObject.message="Before saving the announcement,"
            +" make sure that the permission list (REP user group(s))you specified and the information you entered correct."
            +" To continue, click OK. To make a change, click Cancel.";
            confirmObject.submitCallback = this.submit;
            this.$store.dispatch("setConfirmDialogDetails",confirmObject);
          },
          cancel(){
            this.$router.go(-1);
          },
          async loadCommunication(communicationId){             
             console.log("Load Communication, communication Id:",communicationId)
             const response = await this.$store.dispatch("loadCommunication",communicationId);
             if(response && !response.error){
                this.commId = response.id;
                this.commTitle = response.title;
                this.updateBodyTemplate = response.updateBodyTemplate;
                this.orgTemplateTypeId = response.commTemplateTypeId;

                this.permissionList = response.commPermissions.map(ele => {
                  const userGroup = ele;
                  userGroup.displayName = ele.repGroup;
                  return userGroup;
              });
             }
          },
          async loadCommunicationUpdate(communicationId){             
             console.log("Load CommunicationUpdate, communication Id:",communicationId)
             const response = await this.$store.dispatch("loadCommunicationUpdate",communicationId);
             if(response && !response.error){

                this.copyData(response,this);

                if(response.permissions !=null){
                     this.selectedPermission = response.permissions.map(ele => {
                        const perm = ele;
                        perm.displayName = ele.repGroup;
                        return perm;
                    });
                }
                if(this.templateTypeId != null && this.templateTypeId != 0){
                    this.useTemplate = true;
                }
             }
          },
          async submit(){
            const commUpdatesRequest={};
            this.copyData(this,commUpdatesRequest);

            commUpdatesRequest.permissions = this.selectedPermission.map(ele => {
                const permission = ele;
                permission.type = this.permissionType;
                return permission;
            });
            this.complete = true;
            await this.$store.dispatch("saveCommunicationUpdate",{entity:commUpdatesRequest,userId:this.$store.getters.getUserId,callbackFunc:()=>{
                this.$router.push("/communication/manage");
            }});

                
        },
        copyData(from,to){
            to.id = from.id;
            to.commId = from.commId;
            to.title = from.title;
            to.body = from.body;
            to.addTimeStamp = from.addTimeStamp;
            to.timezoneSname = from.timezoneSname;
            to.templateTypeId  = from.templateTypeId; 
        },
        onUseTemplateChange(){
            if(this.useTemplate){
                this.body = this.updateBodyTemplate;
                this.templateTypeId = this.orgTemplateTypeId;
            }else{
                this.templateTypeId = null;
            }
        }
    },
    beforeRouteLeave(from,to,next){
      //form is not saved
      //fix session expired page not redirect error
        if(!this.complete && from.name !="ErrorPage"){
            const confirmObject = {};
                confirmObject.showDlg= true;
                confirmObject.buttons={
                    OKButton:{
                        Caption:"OK"
                    },
                    CancelButton:{
                        Caption:"Cancel"
                    }
                };
                confirmObject.title="Warning";
                confirmObject.type="Info";
                confirmObject.message="Do you really want to leave? the unsaved changes will be lost.";
                confirmObject.submitCallback =  () =>{
                    next();
                }
                confirmObject.cancelCallback =  () =>{
                    next(false);
                }
                this.$store.dispatch("setConfirmDialogDetails",confirmObject);
                return;
      }else{
          next();
      }
    }
}
</script>
<style lang="scss" scoped>
.main{
     margin-top:1%;
     margin-left:10%;
     margin-bottom: 2%;
     width: 65%;
     height: 100%;
}
</style>
<style lang="scss">
.inputWidth{
    width:40%
}
</style>